module.exports = __webpack_public_path__ + "static/img/default1-1.e04feae3.png";